import type { TOptions, TPlayer } from 'video.js'
import type { SmartlibConfiguration } from './index.h'

import './plugin'

export type {
  AdBreakData,
  AdData,
  AdState,
  SmartlibConfiguration,
  SmartlibPlugin,
  SmartlibPluginOptions,
} from './index.h'

export { EMPTY_AD_STATE } from './index.h'

/**
 * Configure player options for SmartLib
 * This function is called during player creation
 */
export function configure(_configuration: SmartlibConfiguration | undefined) {
  return (options: TOptions): TOptions => {
    // SmartLib doesn't need to modify player options
    // All configuration is handled by the plugin
    return options
  }
}

/**
 * Inject SmartLib plugin into player
 * This function is called after player is created
 */
export function inject(configuration: SmartlibConfiguration | undefined) {
  return (player: TPlayer): TPlayer => {
    // Only initialize plugin if explicitly enabled
    if (configuration?.enabled) {
      player.smartlib?.(configuration)
    }
    return player
  }
}
